import { useEffect, useRef, useState } from 'react'

export const useWindowEventListener = (callBack: any) => {
    const [show, setShow] = useState(false);
    const firstRender = useRef(true);

    useEffect(() => {
        if (firstRender.current) {
            firstRender.current = false;
            return;
        }

        setTimeout(() => {
            if (show) {
                window.addEventListener('click', callBack);
            } else {
                window.removeEventListener('click', callBack);
            }
        }, 0);

        return () => window.removeEventListener('click', callBack);
    }, [show]);

    return [show, setShow] as const;
};
